import { MyLocatorInventoryState } from "../types";
import {
  MyLocatorInventoryActions,
  MyLocatorInventoryActionsType,
} from "./actions";

export const getInitialState = (accountId = ""): MyLocatorInventoryState => ({
  accountId,
  inventoryItems: [],
  allInventoryItems: [],
  isLoading: false,
  isLoadingMore: false,
  isTechnicalError: false,
  isAuthenticationError: false,
  filters: {},
  isFilterApplied: false,
  currentPage: 1,
  pageRowSize: 10,
  totalInventoryItems: 0,
  sortModel: [],
});

export const myLocatorInventoryReducer =
  () =>
  (
    state: MyLocatorInventoryState,
    action: MyLocatorInventoryActions
  ): MyLocatorInventoryState => {
    switch (action.type) {
      case MyLocatorInventoryActionsType.SET_INVENTORY_ITEMS: {
        return {
          ...state,
          inventoryItems: action.payload.inventoryItems,
          totalInventoryItems: action.payload.totalInventoryItems,
        };
      }

      case MyLocatorInventoryActionsType.SET_IS_LOADING:
        return {
          ...state,
          isLoading: action.payload,
        };

      case MyLocatorInventoryActionsType.SET_IS_TECHNICAL_ERROR:
        return {
          ...state,
          isTechnicalError: action.payload,
        };

      case MyLocatorInventoryActionsType.SET_IS_AUTHENTICATION_ERROR:
        return {
          ...state,
          isAuthenticationError: action.payload,
        };

      case MyLocatorInventoryActionsType.SET_FILTER:
        return {
          ...state,
          filters: {
            ...state.filters,
            ...action.payload,
          },
          isFilterApplied: true,
          currentPage: 1,
        };

      case MyLocatorInventoryActionsType.SET_CURRENT_PAGE:
        return {
          ...state,
          currentPage: action.payload,
        };

      case MyLocatorInventoryActionsType.SET_PAGE_ROW_SIZE:
        return {
          ...state,
          pageRowSize: action.payload,
        };

      case MyLocatorInventoryActionsType.SET_TOTAL_INVENTORY_ITEMS:
        return {
          ...state,
          totalInventoryItems: action.payload,
        };

      case MyLocatorInventoryActionsType.SET_SORT_MODEL:
        return {
          ...state,
          sortModel: action.payload,
        };

      case MyLocatorInventoryActionsType.SET_DATE_RANGE_FILTER_ACTION:
        return {
          ...state,
          filters: {
            ...state.filters,
            dateTimeUpdatedFrom: action.payload.startDate,
            dateTimeUpdatedTo: action.payload.endDate,
          },
          isFilterApplied: true,
          currentPage: 1,
        };

      case MyLocatorInventoryActionsType.SET_ALL_INVENTORY_ITEMS:
        return {
          ...state,
          allInventoryItems: action.payload,
        };

      case MyLocatorInventoryActionsType.SET_IS_LOADING_MORE:
        return {
          ...state,
          isLoadingMore: action.payload,
        };

      case MyLocatorInventoryActionsType.APPEND_INVENTORY_ITEMS:
        return {
          ...state,
          allInventoryItems: [...state.allInventoryItems, ...action.payload],
        };

      default:
        return state;
    }
  };
